<!--
 * @Author: your name
 * @Date: 2020-12-03 18:33:08
 * @LastEditTime: 2020-12-11 17:38:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\appointmentQueue\map.vue
-->
<template>
    <div class="appointmentQueue-map">
        <van-nav-bar
            title="预约排队"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
            <template #right>
                <!-- 下拉选择 -->
                <van-dropdown-menu style="color:#fff;right:0">
                    <van-dropdown-item
                        style="right:0"
                        v-model="currentStationId"
                        :options="stationList"
                        @change="changeStation"
                    ></van-dropdown-item>
                </van-dropdown-menu>
            </template>
        </van-nav-bar>
        <div class="container">
            <!-- 模糊搜索 -->
            <div class="search-con">
                <!-- <input v-model="searchVal" @change="onSearch" placeholder="请输入车牌号/供应单号查询"> -->
                <van-search
                    v-model="searchVal"
                    placeholder="请输入车牌号/供应单号查询"
                    clearable
                    @input="onSearch"
                ></van-search>
            </div>
            <div class="change-btn" @click="toList">
                <div>
                    <span class="iconfont iconliebiao1"></span>
                </div>
                <p>列表</p>
            </div>
            <!-- 地图组件 -->
            <baidu-map
                :center="mapCenter"
                :zoom="zoom"
                class="amap-demo"
                @ready="handleReady"
            >
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <!-- 车辆点标记 -->
                <bm-marker
                    v-for="(marker, index) in markers"
                    :key="index"
                    :position="marker.position"
                    :icon="{url: marker.icon, size: marker.size}"
                    :rotation="marker.rotation"
                    @click="switchWindow(index, marker, marker.position)"
                >
                    <bm-label
                        :content="`${marker.plate_number}（${marker.sort_num}）`"
                        :offset="marker.offset"
                    ></bm-label>
                </bm-marker>
                <!-- 场站点标记 -->
                <bm-marker
                    v-for="stationMarker in stationMarkers"
                    :key="stationMarker.station_id"
                    :position="stationMarker.position"
                    :icon="{url: stationMarker.icon, size: stationMarker.size}"
                >
                </bm-marker>
                <!-- 信息窗体 -->
                <bm-info-window
                    :position="windows.position"
                    :show="windows.visible"
                    :offset="windows.offset"
                    :close-on-click="true"
                    class="car-info-window"
                >
                    <div class="container">
                        <div class="top">
                            <span class="iconfont iconorder"></span>
                            <span>供应单号:{{ switchData.supply_no }}</span>
                        </div>
                        <div class="middle">
                            <div>
                                <span v-if="switchData.type_name">{{ switchData.type_name }}</span>
                                <span v-if="switchData.goods_name">-{{ switchData.goods_name }}</span>
                                <span v-if="switchData.spec_name">-{{ switchData.spec_name }}</span>
                            </div>
                            <div>当前排在第<span class="num">{{ switchData.sort_num }}</span>位</div>
                        </div>
                        <div class="time-con">
                            <div>
                                <div class="time">
                                    {{ switchData.begin_time }}
                                </div>
                                <div class="lable">
                                    出厂时间
                                </div>
                            </div>
                            <div class="arrow-con">
                                <div class="distanse">
                                    {{ switchData.to_distance }}km
                                </div>
                                <div class="distanse">
                                    <span class="tag">{{ switchData.plate_number }}</span>
                                </div>
                            </div>
                            <div>
                                <div class="time">
                                    {{ switchData.estimated_time }}
                                </div>
                                <div class="lable">
                                    出厂时间
                                </div>
                            </div>
                        </div>
                    </div>
                </bm-info-window>
            </baidu-map>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import BaiduMap from 'vue-baidu-map';
// import GeoUtils from '@/plugins/BMapLibGeoUtils/index';
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: '8oGi1YBeLNnGA54yA1YuyumkzjjfGqmW',
});
export default {
    components: {},
    props: {},
    data() {
        return {
            // 缩放比例
            zoom: 15,
            // 地图中心点
            mapCenter: { lng: 116.404, lat: 39.915 },
            // 模糊搜索
            keyword: '',
            // 搜索范围
            searchOption: '全国',
            // map对象
            BMap: {},
            // map实例对象
            mapObj: {},
            // 列表搜索条件
            searchVal: '',
            // 场站
            stationList: [],
            stationListSource: [],
            // 当前场站id
            currentStationId: '',
            // 运输单列表
            list: [],
            // 点标记
            markers: [],
            // 点信息窗体
            windows: {
                position: { lng: 0, lat: 0 },
                visible: false,
                offset: { width: -10, height: -20 },
            },
            switchData: {},
            // 场站点标记
            // stationMarker: {
            //     position: { lng: 0, lat: 0 },
            //     icon: require('../../../assets/images/orderSitiation/station.png'),
            //     size: { width: 30, height: 30 },
            // },
            stationMarkers: [],

        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.getStationUser();
        setInterval(() => {
            this.getCarsLocation();
        }, 60000);
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转到列表页
        toList() {
            this.$router.isBack = 2;
            this.$router.push({ path: '/appointmentQueueList' });
        },
        // 地图加载完毕
        handleReady({ BMap, map }) {
            this.BMap = BMap;
            this.mapObj = map;
            // 开启鼠标滚动缩放地图
            map.enableScrollWheelZoom(true);
            // 设置中心点、缩放级别
            // this.mapCenter.lng = 116.404;
            // this.mapCenter.lat = 39.915;
            // this.zoom = 15;
            // this.windows.visible = true;
        },
        // 点击点标记弹出信息窗体
        switchWindow(tab, item, position) {
            this.switchData = item;
            this.windows.visible = false;
            this.windows.position = position;
            this.$nextTick(() => {
                this.windows.visible = true;
            });
            // const plate_number = item.plate_number;
            // this.getVehicleNo(plate_number, tab);
        },
        // 更换场站
        changeStation() {
            this.getCoordinate(this.currentStationId);
            this.getCarsLocation();
        },
        // 模糊搜索
        onSearch() {
            this.getCarsLocation();
        },
        // 获取坐标
        getCoordinate(ids) {
            this.$axios.get('/interfaceApi/baseinfo/stationmanger/get_coordinate_notoken?stationIds=' + ids).then(res => {
                if (res[0].longitude && res[0].latitude) {
                    const markObj = {
                        position: { lng: res[0].longitude, lat: res[0].latitude },
                        icon: require('../../../assets/images/orderSitiation/station.png'),
                        size: { width: 30, height: 30 },
                    };
                    this.stationMarkers = [markObj];
                    this.mapCenter = { lng: res[0].longitude, lat: res[0].latitude };
                }
            });
        },
        // 拉取用户关联场站
        getStationUser() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        value: id,
                        text: stationNames[index],
                    };
                });
                this.stationList = stationList;
                this.currentStationId = stationList[0].value;
                this.getCoordinate(this.currentStationId);
                this.getCarsLocation();
            }
        },
        // 拉取场站下所有车辆位置
        async getCarsLocation() {
            const res = await this.$axios.$get('/interfaceApi/wechat/carlocation/get_cars_location?station_id='
            + this.currentStationId + '&keywords=' + this.searchVal);
            if (res) {
                // let arr = [
                //     {
                //         supply_no: '【SP】GYD202011-006',
                //         plate_number: '33333333',
                //         longitude: 123.456,
                //         latitude: 39.85856,
                //         speed: 31.318429771532895,
                //         direction: 270.0,
                //         to_distance: 77846.134397532936,
                //         sort_num: 1,
                //         begin_time: '2020-12-01 09:36:18',
                //         estimated_time: '2020-12-03 18:02:14',
                //         type_name: '石',
                //         goods_name: '卵石',
                //         spec_name: '16-31.5',
                //     },
                // ];
                if (res.length > 0) {
                    this.mapCenter = { lng: res[0].longitude, lat: res[0].latitude };
                    let arr = [];
                    const markers = [];
                    arr = res.map(item => {
                        if (item.to_distance) {
                            item.to_distance = (item.to_distance / 1000).toFixed(2);
                        }
                        if (item.begin_time) {
                            item.begin_time = item.begin_time.substr(11, item.begin_time.length);
                        }
                        if (item.estimated_time) {
                            item.estimated_time = item.estimated_time.substr(11, item.estimated_time.length);
                        }
                        const markObj = {
                            position: { lng: item.longitude, lat: item.latitude },
                            icon: require('../../../assets/images/productionManagement/blue.png'),
                            size: { width: 28, height: 45 },
                            offset: { width: -20, height: 40 },
                            rotation: item.direction,
                            plate_number: item.plate_number,
                        };
                        const newObj = { ...markObj, ...item };
                        markers.push(newObj);
                        return item;
                    });
                    this.markers = markers;
                    this.list = arr;
                } else {
                    this.list = [];
                    this.markers = [];
                }

            }
        },
    },
};
</script>
<style lang="stylus">
.appointmentQueue-map
    height 100%
    .van-dropdown-menu__bar
        background-color transparent
        height 40rpx
        .van-dropdown-menu__title
            color #fff
    .van-nav-bar
        z-index 2
    .container
        height calc(100% - 40rpx)
        position relative
        .search-con
            position absolute
            top 15rpx
            left 15rpx
            width calc(100% - 30rpx)
            z-index 1
            box-shadow 2px 2px 4px 0px rgba(0, 0, 0, 0.2)
            .van-search
                height: auto!important;
                padding 0
            // input
            //     height 32rpx
            //     background #FFFFFF
            //     box-shadow 2rpx 2rpx 4rpx 0 rgba(0, 0, 0, 0.2)
            //     border-radius 4rpx
            //     width 100%
            //     border none
            //     padding 0 10rpx
            //     &::placeholder
            //         font-size .12rem
            //         color #D7D7D7
        .change-btn
            padding 5rpx 10rpx 10rpx 10rpx
            background #0189FC
            box-shadow 2rpx 2rpx 4rpx 0 rgba(0, 0, 0, 0.35)
            border-radius 4rpx
            position absolute
            bottom 15rpx
            right 20rpx
            z-index 10
            text-align center
            color #fff
            .iconfont
                font-size 28rpx
            p
                font-size 12rpx
        .amap-demo
            width 100%
            height 100%
            .car-info-window
                .container
                    width 280rpx
                    height 140rpx
                    .top
                        color #0189FC
                        line-height 32rpx
                        .iconfont
                            margin-right 5rpx
                    .middle
                        display flex
                        justify-content space-between
                        align-items center
                        height 35rpx
                        background-color #F0F0F0
                        padding 0 10rpx
                        >div
                            &:nth-child(1)
                                font-size 14rpx
                            &:nth-child(2)
                                font-size 12rpx
                                .num
                                    font-size 16rpx
                                    color #FF6600
                    .time-con
                        display flex
                        // align-items center
                        height 59rpx
                        padding 15rpx
                        .arrow-con
                            background url(./../../../assets/images/productionManagement/arrow_blue.png) no-repeat bottom center
                            width 148rpx
                            height 22rpx
                            margin 0 10rpx
                            background-size 100%
                            .distanse
                                text-align center
                                color #6DD400
                        .time
                            font-size 14rpx
                        .lable
                            font-size 12rpx
                            color #979EA7
                        .tag
                            padding 2rpx 5rpx
                            font-size 12rpx
                            color #FF8534
                            margin-right 10rpx
                            margin-top 10rpx
</style>
